import { type MCPServerInfo } from '../../types';

const ApiiroServer: MCPServerInfo = {
  serverId: 'APIIRO',
  name: 'Apiiro',
  slug: 'apiiro',
  description:
    'Apiiro Guardian Agent — Application Security Posture Management (ASPM) for AI coding assistants. Write secure code, query security risks, trigger diff scans, and manage findings.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.apiiro.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default ApiiroServer;
